// extracted by mini-css-extract-plugin
module.exports = {"v157q6bx":"v157q6bx"};